var _circle, _circle2, _path, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChasingGhosts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    "aria-label": "Chasing Ghosts Symbol",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 60,
    r: 15,
    fill: "none",
    stroke: "rgba(200,200,255,0.4)",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 60,
    r: 30,
    fill: "none",
    stroke: "rgba(200,200,255,0.2)",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,160 C60,130 80,90 100,100 C120,110 140,150 160,60",
    fill: "none",
    stroke: "rgba(80,80,200,0.7)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "6 3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 160,
    r: 8,
    fill: "rgba(80,80,200,0.9)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 60,
    r: 10,
    fill: "none",
    stroke: "rgba(150,150,255,0.8)",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 80,
    r: 6,
    fill: "rgba(150,150,255,0.5)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 95,
    r: 4,
    fill: "rgba(150,150,255,0.3)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 110,
    r: 3,
    fill: "rgba(150,150,255,0.1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChasingGhosts);
export default __webpack_public_path__ + "static/media/ChasingGhosts.c8cdc6b53b429908956f51ce4d3ef45c.svg";
export { ForwardRef as ReactComponent };